import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=aed0fea4&scoped=true&"
import script from "./ConfirmDelete.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed0fea4",
  null
  
)

export default component.exports